module.exports = __webpack_public_path__ + "static/img/LogoPMS.a0f61e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/LogoPMS.svg
// module id = tz3W
// module chunks = 15